// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__TZ5rZ","balanceDisclaimer":"posDashboard_balanceDisclaimer__3g0MR"};